/**
 * Time formatting utilities
 */

/**
 * Format seconds to HH:MM:SS or MM:SS format
 * @param {number} seconds - Total seconds
 * @returns {string} Formatted time string
 */
export function formatSecondsToTime(seconds) {
  if (!seconds || seconds < 0) return '0:00:00'
  
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = Math.floor(seconds % 60)
  
  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
  } else {
    return `${minutes}:${secs.toString().padStart(2, '0')}`
  }
}

/**
 * Format time difference from now in Polish
 * @param {Date} time - The time to compare
 * @returns {string} Formatted time difference
 */
export function formatTimeFromNow(time) {
  const now = new Date()
  const diffMinutes = Math.floor((now - time) / 1000 / 60)
  
  if (diffMinutes < 1) {
    return 'teraz'
  } else if (diffMinutes < 60) {
    return `${diffMinutes} min temu`
  } else if (diffMinutes < 1440) { // Less than 24 hours
    const hours = Math.floor(diffMinutes / 60)
    return `${hours}h temu`
  } else { // More than 24 hours
    return `wczoraj o ${time.toLocaleTimeString('pl-PL', { 
      hour: '2-digit', 
      minute: '2-digit' 
    })}`
  }
}

/**
 * Format time to Polish locale string
 * @param {Date|string} time - Time to format
 * @returns {string} Formatted time string
 */
export function formatTime(time) {
  if (!time) return '--:--'
  
  const date = typeof time === 'string' ? new Date(time) : time
  return date.toLocaleTimeString('pl-PL', {
    hour: '2-digit',
    minute: '2-digit'
  })
}